export const INPUT_TYPES = {
    TEXT: 'text',
    EMAIL: 'email',
    SELECT: 'select',
    AUTOCOMPLETE: 'autocomplete',
    NUMBER: 'number',
    CHECKBOX: 'checkbox',
    MULTIPLE_SELECT: 'multiple-select',
    DATE: 'date',
    DATETIME: 'datetime-local',
};
